import { render, staticRenderFns } from "./AttributeDescriptionDialog.vue?vue&type=template&id=20059e42"
import script from "./AttributeDescriptionDialog.vue?vue&type=script&lang=ts"
export * from "./AttributeDescriptionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports